export default "__VITE_ASSET__DtumOFjQ__"